export var isPathRoute = function (route) {
    return route.pathname !== undefined;
};
export var isActionRoute = function (route) {
    return route.action !== undefined;
};
